/**
 * Auto-generated prismacide icon component.
 */
import { default as DefaultIcon } from '~icons/prismacide/shippers';
import { Icon, type IconProps } from 'src/components/media-and-icons/icon';

export const ShippersIcon = (props: IconProps) => (
  <Icon icon={DefaultIcon} {...props} />
);
